<template>
  <div class="row">
    <div class="col-md-10 offset-md-1">
      <el-divider class="divider-green"></el-divider>
    </div>
    <div class="offset-md-1 col-md-6">
      <el-card class="box-card" shadow="always">
        <div v-if="!isPartnerAccount" class="row">
          <div class="col-sm-12">
            <h3>General Remarks (displayed on ACSA Form)</h3>
            <div class="pt-20">
              <el-input
                type="textarea"
                :rows="3"
                :disabled="!isOrderIdAvailable || isReadOnly"
                maxlength="700"
                show-word-limit
                placeholder="..."
                v-model="remark"
              >
              </el-input>
              <div>
                <span>{{ remarkCharacterCountMessage }}</span>
              </div>
              <div v-if="hasErrorRemarks" class="pt-20">
                <el-alert
                  type="error"
                  :closable="false"
                  show-icon
                  title="Error saving remark. Please re-try again."
                >
                </el-alert>
              </div>
              <div class="pt-20">
                <el-alert
                  type="warning"
                  :closable="false"
                  show-icon
                  title="Excessive line breaks may reduce the visibility of text on the
                printed form 1-3A regardless of character count"
                  effect="dark"
                >
                </el-alert>
              </div>
              <div class="row pt-20">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <base-button
                      type="primary"
                      wide
                      :disabled="!isOrderIdAvailable || isReadOnly"
                      @click.prevent="saveRemark"
                      class="btn-next"
                      >Save</base-button
                    >
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr v-if="!isPartnerAccount" />
        <div v-show="!isPartnerAccount" class="row">
          <div class="col-lg-12">
            <el-radio-group fill="#10b45a"  v-model="currentTab">
      <el-radio-button label="U.S."></el-radio-button>
      <el-radio-button label="Partner Nation"></el-radio-button>
      </el-radio-group>
          </div>
        </div>
        <br/>
        <div class="row pt-20">
          <div 
            v-show="currentTab === 'U.S.'"
            ref="U.S."
            class="col-sm-12 tabs__active-line"
          >
            <h3>U.S. Discussion</h3>
             <Mentionable
                :keys="['@']"
                :items="users"
                @open="loadUsers()"
                placement="bottom"
                insert-space
                offset="6"
              >
                <textarea
                  rows="5"
                  :disabled="!isOrderIdAvailable"
                  placeholder="Add a comment. Use @ to mention a user..."
                  class="el-textarea__inner"
                  v-model="form.comment"
                />
                <template #no-result>
                  {{ loading ? "Loading..." : "No result" }}
                </template>

                <template #item-@="{ item }">
                  <div class="user">
                    {{ item.label }}
                  </div>
                </template>
              </Mentionable>
          </div>
          <div 
            v-show="currentTab === 'Partner Nation'" 
            class="col-sm-12"
            ref="Partner Nation"
            >
            <h3>{{partnationSubtitle}}</h3>
            <div class="pt-20">


              <div v-if="!isOUSD" class="pt-20">
              <Mentionable
                :keys="['@']"
                :items="users"
                @open="loadUsers()"
                placement="bottom"
                insert-space
                offset="6"
              >
                <textarea
                  rows="5"
                  :disabled="!isOrderIdAvailable"
                  placeholder="Add a comment. Use @ to mention a user..."
                  class="el-textarea__inner"
                  v-model="form.comment"
                />
                <template #no-result>
                  {{ loading ? "Loading..." : "No result" }}
                </template>

                <template #item-@="{ item }">
                  <div class="user">
                    {{ item.label }}
                  </div>
                </template>
              </Mentionable>
            </div>
             <div v-else class="pt-20">
             
                <textarea
                  rows="5"
                  :disabled="!isOrderIdAvailable"
                  placeholder="Add a comment."
                  class="el-textarea__inner"
                  v-model="form.comment"
                ></textarea>
            </div>
            </div>
          </div>
        </div>
        <div class="row pt-20">
          <div class="col-sm-12">
            <div class="pull-right">
              <base-button
                type="primary"
                wide
                :disabled="!isOrderIdAvailable"
                @click.prevent="addDiscussion"
                >Send</base-button
              >
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="col-md-4 max-height">
      <div class="pt-1">
        <div class="search-box">
          <el-input
            :disabled="
              this.filteredDiscussions.length === 0 && !this.isOrderIdAvailable
                ? true
                : false
            "
            v-model="search"
            placeholder="search discussions"
          />
        </div>
        <el-timeline
          v-if="filteredDiscussions.length > 0 && this.isOrderIdAvailable"
        >
          <el-timeline-item
            v-for="(item, index) in filteredDiscussions"
            :timestamp="localtimeZone(item.commentDate) | formatDateTime"
            :key="index"
            placement="top"
          >
            <el-card>
              <div class="row">
                <div class="col-md-12">
                  <h4>Comment By: {{ item.userEmail }}</h4>
                  <el-alert :closable="false" v-html="item.comment" type="info">
                  </el-alert>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <el-card v-else>
          <div class="text-center pt-4">
            <h2>
              No Discussion Info Available!
            </h2>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Mentionable } from "vue-mention";
import {
  Button,
  Alert,
  Input,
  Divider,
  Card,
  Timeline,
  Tag,
  TimelineItem,
  RadioGroup,
  RadioButton
} from "element-ui";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import Util from "@/util/util";

export default {
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    isPartnerAccount: {
      type: Boolean,
      default: false
    }
  },
  components: {
    [Card.name]: Card,
    [Button.name]: Button,
    [Alert.name]: Alert,
    [Divider.name]: Divider,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Timeline.name]: Timeline,
    [TimelineItem.name]: TimelineItem,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    Mentionable,
  },
  created() {
     this.getApprovalStatuses();
  },
  watch: {
    activeTab(newTab, oldTab) {
      if (newTab == "Remarks") {
        this.loadRemarkData(true);
      }
    },
    toggleUsUser(newVal, oldVal){
      if(newVal !== oldVal){
        this.clearForm()
      } 
      },
    async currentTab(newVal, oldVal) {
      if (newVal != oldVal) {
        this.form.comment = ''     
        if (newVal === 'U.S.') {
          this.toggleUsUser = true
       await this.getDiscussions(this.orderId);

        } else {
          this.toggleUsUser = false
       await this.getDiscussions(this.orderId);

        }
      }
    }
  },
  data() {
    return {
      partnationSubtitle: this.isPartnerAccount ? "Discussion" : "Partner Nation Discussion",
      subPages: [
        {
          title: 'U.S.',
          value: "US",
          disabled: this.isPartnerAccount
        },
        {
          title:'Partner Nation',
          value: "PartnerNation"
        },
      ],
      selectedDocumentType: '',
      activeLineWidth: 0,
      activeLineOffset: 0,
      currentTab: this.isPartnerAccount ? 'Partner Nation' : 'U.S.',
      form: {
        orderId: null,
        userId: null,
        userEmail: null,
        taggedUsers: [],
        remark: "",
        comment: "",
        commentDate: null,
      },
      toggleUsUser: false,
      loading: false,
      search: "",
      users: [],
      user: null,
      remark: "",
      hasErrorRemarks: false,
      discussions: [],
      error: null,
      isUsActive: true,
      isPartnerNationActive: false,
      selectedUsers: []
    };
  },
  filters: {
    formatDateTime(value) {
      if (!value) return "";
      return moment(value).format("DD-MMMM-YYYY HH:mm");
    },
  },
  mounted() {
    if (this.isPartnerAccount) {
      this.currentTab = "Partner Nation"
      this.toggleUsUser = false
    }
  },
  computed: {
    ...mapGetters({
      activeTab: "tab/activeTab",
      orderIdFromPreOrderDetail: "preOrderDetail/preOrder",
      isOUSD: "authentication/isOUSD",
        approvalStatuses: "approvalStatus/approvalStatuses",
    }),
    filteredDiscussions() {
      if (this.discussions) {
        if (this.search.length > 0) {
          const searchString = this.search.toLowerCase();

          const res = this.discussions
            .sort(function (a, b) {
              let da = new Date(a.commentDate),
                db = new Date(b.commentDate);
              return db - da;
            })
            .filter((obj) =>
              Object.values(obj).some((val) => {
                  if(val != null)
                    return val.toString().toLowerCase().includes(this.search);
                  else
                    return '';
                }
              )
            );

          return res;
        }
        return this.discussions.sort(function (a, b) {
          let da = new Date(a.commentDate),
            db = new Date(b.commentDate);
          return db - da;
        });
      } else {
        return [];
      }
    },
    remarkCharacterCountMessage() {
      if (this.remark && this.remark.length != null) {
        return 700 - this.remark.length + " Characters Remaining";
      } else {
        return "700 Characters Remaining";
      }
    },
    orderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    orderId() {
      if (this.isOrderIdAvailable && this.orderIdFromRoute !== 0) {
        return this.orderIdFromRoute;
      } else {
        return this.orderIdFromPreOrderDetail.orderId;
      }
    },
    isOrderIdAvailable() {
      return (
        this.orderIdFromRoute != 0 ||
        (this.orderIdFromRoute != 0 &&
          this.orderIdFromPreOrderDetail &&
          this.orderIdFromPreOrderDetail.orderId != 0)
      );
    },
  },
  methods: {
    ...mapActions({
      getApprovalStatuses: "approvalStatus/getApprovalStatuses",
    }),
    moveActiveContent(newValue) {
      if(newValue === 'US') {
        this.loadRemarkData(true);
      } else if(newValue === 'PartnerNation') {
        this.loadRemarkData(false);
      }
    },
    handleClick(newTab) {
      this.currentTab = newTab;
    },
    async getUser() {
      await this.axios
        .get("/api/applicationusers/email")
        .then((res) => {
          this.user = res.data;
        })
        .catch((err) => {
          this.error = err.response
        });
    },
    async getRemark(orderId) {
      await this.axios
        .get(`/api/ordernotes/${orderId}`)
        .then((res) => {
          this.remark = res.data.remarks;
        })
        .catch((err) => {
          this.error = err.response
        });
    },
    async getUsers() {
      this.users = []
      await this.axios
        //.get("/api/applicationusers")
        .get(`/api/applicationusers/remark/users/${this.orderId}/${false}`)
        .then((res) => {
          const filteredUsersList = res.data.map((user) => {
            const lockedStatus = this.approvalStatuses.find(a => a.name === 'LOCKED')
            const usersList = {};
            if (user.approvalStatusId != lockedStatus.approvalStatusId) {
              usersList["label"] = user.firstName
                ? `${user.firstName} ${user.lastName} (${user.email})`
                : user.email;
                usersList["value"] = user.email;
              return usersList;
            }
          });
          this.users = filteredUsersList;
        })
        .catch((err) => {
          this.error = err.response
        });
    },
    async getPartnerNationUser() {
      this.users = []
      await this.axios
        //.get("/api/applicationusers")
        .get(`/api/applicationusers/remark/users/${this.orderId}/${true}`)
        .then((res) => {
          const filteredUsersList = res.data.map((user) => {
            const usersList = {};
            usersList["label"] = user.firstName
              ? `${user.firstName} ${user.lastName} (${user.email})`
              : user.email;
              usersList["value"] = user.email;

            return usersList;
          });
          this.users = filteredUsersList;
        })
        .catch((err) => {
          this.error = err.response
        });
    },
    async getDiscussions(orderId) {
      await this.axios
        .get(`/api/orderdiscussions/order/${orderId}/${this.toggleUsUser}`)
        .then((res) => {
          this.discussions = res.data;
        })
        .catch(
          (
            err ///{
          ) => this.error = err.response
        );
    },
    async loadRemarkData(toggleUsUser) {
      this.getUser();

      if(this.isPartnerAccount) {
        this.toggleUsUser = false;
        this.isPartnerNationActive = true;
        this.isUsActive = false;
        await this.getPartnerNationUser();
      } else {

        // Fetch Documents if Order Id is available
        if (this.isOrderIdAvailable) {
          this.toggleUsUser = toggleUsUser
          if(!toggleUsUser) {
            this.isPartnerNationActive = true;
            this.isUsActive = false;
            await this.getPartnerNationUser();
          }
          else {
            this.isPartnerNationActive = false;
            this.isUsActive = true;
            await this.getUsers();
          }
        }

        this.discussions.sort(function (a, b) {
          if (Date.parse(a.commentDate) > Date.parse(b.commentDate)) return 1;
          if (Date.parse(a.commentDate) < Date.parse(b.commentDate)) return -1;
          return 0;
        });
      }
      await this.getRemark(this.orderId);
      await this.getDiscussions(this.orderId);
    },
    async loadUsers() {
      this.loading = true;
        if(!this.toggleUsUser){
          await this.getPartnerNationUser();
        }else {
                await this.getUsers();
        }
          this.loading = false;
    },
      extractTaggedUsers() {
      let users = this.form.comment.match(
        /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi
      );
      let selectedUsersTemp = users && users.length > 0 ? users : [];     
      let taggableUserEmails = this.users.map(u => u.value);
      this.form.taggedUsers = selectedUsersTemp.filter(u => taggableUserEmails.includes(u));
      this.selectedUsers = selectedUsersTemp.filter(u => taggableUserEmails.includes(u));
      return;
    },
    // Save a Remark
    async saveRemark() {
      if (this.isOrderIdAvailable) {
        let formData = {
          orderId: this.orderId,
          remarks: this.remark,
        };
        await this.postRemark(formData).then(() => {
          this.remark = ''
        }).catch(err => {
          this.error = err.response
          this.$toast.error("Error saving remark!!")
        });
      }
    },
    async postRemark(formData) {
      await this.axios
        .post("/api/ordernotes", formData)
        .then((res) => {})
        .catch((err) => {
          this.error = err.response
          this.hasErrorRemarks = true
        });
    },
    async postDiscussion(formData) {
      await this.axios.post("/api/orderdiscussions", formData).then((res) => {
        this.getDiscussions(this.orderId);
      }).catch(err => this.error = err.response);
    },
    // Saving a Discussion
    async addDiscussion() {
      if (this.isOrderIdAvailable) {
        this.extractTaggedUsers();
        let formData = {
          orderId: this.orderId,
          userId: this.user.id,
          userEmail: this.user.email,
          comment: this.form.comment,
          taggedUsers: this.selectedUsers, //this.form.taggedUsers,
          UsDicussion: this.toggleUsUser,
          commentDate: new Date(),
        };
        this.clearForm();
        await this.postDiscussion(formData);
        this.getDiscussions(this.orderId);
      }
    },
    // Clearing form data
    clearForm() {
      this.form.comment = "";
      this.form.taggedUsers = [];
      this.form.commentDate = null;
    },
    localtimeZone(date){
      return Util.formatDateWithLocalTimezone(date);
    },
  },
};
</script>

<style scoped lang="scss">
.btn-primary {
  /* background-color: #10b45a; */
  color: #fff;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-primary:hover {
  border-color: #10b45a;
  color: #fff;
  background-color: #10b45a;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-primary:focus {
  color: #fff;
  outline-color: transparent;
}

.btn-secondary:focus {
  outline-color: transparent;
}

.btn-secondary-dark:focus {
  outline-color: transparent;
}

.divider-green {
  background-color: #10b45a;
}

.btn-secondary {
  background-color: #d3d7e9;
  border: none;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-secondary:hover {
  background-color: #cccccc;
  color: #1d253b;
  border-color: #cccccc;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-secondary-dark {
  background-color: #cccccc;
}

.btn-secondary-dark:hover {
  background-color: #d3d7e9;
  border: none;
  color: #1d253b;
}

.edit-cell {
  min-height: 35px;
  cursor: pointer;
}

.el-input__inner {
  border: 1px solid #10b45a;
}

.el-button.editing {
  color: #fff;
  border-color: red;
  background-color: red;
}

.content {
  margin-top: 30px;
  font-size: 20px;
}

.max-height {
  max-height: 100vh !important;
  overflow: scroll !important;
}
</style>
